import {UUID} from '@/plugins/common'
import _ from 'lodash'

export default class Notice {
  // 开启通知开关
  enable = true
  id = ''
  // 通知方式
  ways = []
  // 默认内容还是自定义内容
  selectContent = 'defaultContent'
  // 内容模板
  template = ''
  processTitle='流程处理提醒'
  targetNode = []
  targetUser = []
  targetComponent = []

  constructor (args = {}) {
    _.merge(this, args)
  }

  static create (args) {
    args.id = '_' + UUID.create()
    args.ways = ['email', 'app']
    let notice = new Notice(args)
    let content = 'processName'
    let startName = 'startName'
    let startTime = 'startTime'
    notice.processTitle = '流程处理提醒(${' + startName + '})'
    notice.template = '${' + startName + '}在${' + startTime + '}向您发起了${' + content + '}流程，请及时处理'
    return notice
  }

  static load (args) {
    args.ways = JSON.parse(args.ways)
    args.targetNode = JSON.parse(args.targetNode)
    args.targetUser = JSON.parse(args.targetUser)
    args.targetComponent = JSON.parse(args.targetComponent)
    args.id = '_' + UUID.create()
    let notice = new Notice(args)
    return notice
  }
}



// WEBPACK FOOTER //
// ./src/store/process/notice.js